import { render, staticRenderFns } from "./BiossegurancaCCS.vue?vue&type=template&id=e36eaa90&scoped=true"
import script from "./BiossegurancaCCS.vue?vue&type=script&lang=js"
export * from "./BiossegurancaCCS.vue?vue&type=script&lang=js"
import style0 from "./BiossegurancaCCS.vue?vue&type=style&index=0&id=e36eaa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36eaa90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VCol,VRow})
